const BroadcastModule = () => import('@/modules/BroadcastModule')
const NewsBroadcast = () => import('@/modules/NewsBroadcast')
const DocumentBroadcast = () => import('@/modules/DocumentBroadcast')

export default [
	{
		component: BroadcastModule,
		name: 'broadcast',
		path: 'broadcast/:context?',
		children: [
			{
				component: NewsBroadcast,
				name: 'broadcast-news',
				path: 'news'
			},
			{
				component: DocumentBroadcast,
				name: 'broadcast-documents',
				path: 'documents'
			}
		]
	}
]
